export interface FilterData {
  field: string;
  type: FilterType;
  values: string[];
  min?: number | Date;
  max?: number | Date;
}

export enum FilterType {
  CHOICE = 'choice',
  RANGE = 'range',
  TEXT = 'text',
}
export interface FilterableValue {
  value: string | number;
  label: string;
  count: number;
}

export interface FilterableField {
  fieldRef: string;
  values: FilterableValue[];
  count: number;
}
